module.exports = __webpack_public_path__ + "img/sprite.717c6ca1.svg";